"use strict";
exports.__esModule = true;
exports.recordExpressionFunctions = void 0;
var records_1 = require("../records");
var node_1 = require("../../node");
var utils_1 = require("../../utils");
var survey_1 = require("../../survey");
var geo_1 = require("../../geo");
var dates_1 = require("../../utils/dates");
exports.recordExpressionFunctions = [
    {
        name: 'categoryItemProp',
        minArity: 3,
        executor: function (context) { return function (categoryName, itemPropName) {
            var _a;
            var codePaths = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                codePaths[_i - 2] = arguments[_i];
            }
            var survey = context.survey;
            var category = survey_1.Surveys.getCategoryByName({ survey: survey, categoryName: categoryName });
            if (!category)
                return null;
            var categoryItem = survey_1.Surveys.getCategoryItemByCodePaths({ survey: survey, categoryUuid: category.uuid, codePaths: codePaths });
            if (!categoryItem)
                return null;
            var extraProp = (_a = categoryItem.props.extra) === null || _a === void 0 ? void 0 : _a[itemPropName];
            return utils_1.Objects.isEmpty(extraProp) ? null : extraProp;
        }; }
    },
    {
        name: 'distance',
        minArity: 2,
        maxArity: 2,
        executor: function () { return function (coordinateFrom, coordinateTo) {
            var toPoint = function (coordinate) {
                return coordinate && typeof coordinate === 'string' ? geo_1.Points.parse(coordinate) : coordinate;
            };
            var pointFrom = toPoint(coordinateFrom);
            var pointTo = toPoint(coordinateTo);
            return pointFrom && pointTo ? geo_1.Points.distance(pointFrom, pointTo) : null;
        }; }
    },
    {
        name: 'index',
        minArity: 1,
        maxArity: 1,
        evaluateArgsToNodes: true,
        executor: function (context) { return function (node) {
            if (!node) {
                return -1;
            }
            if (node_1.Nodes.isRoot(node)) {
                return 0;
            }
            var record = context.record;
            var parentNode = records_1.Records.getParent({ record: record, node: node });
            if (!parentNode) {
                return -1;
            }
            var children = records_1.Records.getChildren({ record: record, parentNode: parentNode, childDefUuid: node.nodeDefUuid });
            return children.findIndex(function (n) { return node_1.Nodes.areEqual(n, node); });
        }; }
    },
    {
        name: 'now',
        minArity: 0,
        maxArity: 0,
        evaluateToNode: false,
        executor: function () { return function () { return dates_1.Dates.nowFormattedForStorage(); }; }
    },
    {
        name: 'parent',
        minArity: 1,
        maxArity: 1,
        evaluateArgsToNodes: true,
        evaluateToNode: true,
        executor: function (context) { return function (node) {
            if (!node || node_1.Nodes.isRoot(node)) {
                return null;
            }
            var record = context.record;
            return records_1.Records.getParent({ record: record, node: node });
        }; }
    },
    {
        name: 'taxonProp',
        minArity: 3,
        maxArity: 3,
        executor: function (context) { return function (taxonomyName, propName, taxonCode) {
            var _a;
            var survey = context.survey;
            var taxonomy = survey_1.Surveys.getTaxonomyByName({ survey: survey, taxonomyName: taxonomyName });
            if (!taxonomy)
                return null;
            var taxon = survey_1.Surveys.getTaxonByCode({ survey: survey, taxonomyUuid: taxonomy.uuid, taxonCode: taxonCode });
            if (!taxon)
                return null;
            var extraProp = (_a = taxon.props.extra) === null || _a === void 0 ? void 0 : _a[propName];
            return utils_1.Objects.isEmpty(extraProp) ? null : extraProp;
        }; }
    },
];
//# sourceMappingURL=functions.js.map